  <template>
  <div class="contato">
    <div class="container">
      <h1 class="display-1 mt-3">Fale Conosco</h1>
      <v-divider></v-divider>
      <v-layout wrap class="my-3">
        <v-flex xs12 md12 lg12 class="mb-4">
          <div>
            <p class>
              <span class="title">{{ canaisAtendimento }}</span>
            </p>
          </div>

          <a class="form-link" :href="linkMovidesk" target="_blank" v-if="habilitadoLinkFaleConosco">
            <v-btn class="my-2" small color="primary" outlined>
              <v-icon small left>exit_to_app</v-icon>
              <span>Clique aqui para preencher o formulário de contato</span>
            </v-btn>
          </a>

          <p class="caption" v-if="!messageDadosContato">Obs. Será aberto em uma nova guia do navegador.</p>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 md6></v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService";

export default {
  props: {
    endereco: {
      type: String,
    },
    telefone: {
      type: String,
    },
    linkMovidesk: {
      type: String,
    },

    canaisAtendimento: {
      type: String,
    },

    textoExplicativoWebService: {
      tupe: String,
    },

    habilitadoLinkFaleConosco: {
      type: Boolean,
    }
  },
  data() {
    return {
      messageDadosContato: "",
    }
  },
  created() {
    EventService
        .getBundle("message.portalDadosContato")
        .then(res => this.messageDadosContato = res.data)
  }
};
</script>

<style>
  .form-link {
    text-decoration: none;
  }
</style>